<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="table-container">
<table mat-table [dataSource]="scenarioTemplateDataSource" matSort multiTemplateDataRows>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>
      @if (hasPermission(SystemPermission.CreateScenarioTemplates)) {
      <button mat-icon-button (click)="editScenarioTemplate(null); $event.stopPropagation()"
        style="outline: none; margin-left: 20px;" title="Add Scenario Template">
        <mat-icon class="mdi-24px" fontIcon="mdi-plus-circle"></mat-icon>
      </button>
      }
    </th>
    <td mat-cell *matCellDef="let element">
      @if (hasPermission(SystemPermission.CreateScenarioTemplates)) {
      <button mat-icon-button ngxClipboard [cbContent]="element.id" (click)="$event.stopPropagation()"
        style="outline: none;" title="Copy ID:  {{ element.id }}">
        <mat-icon class="mdi-18px" fontIcon="mdi-content-copy"></mat-icon>
      </button>
      }
      @if (canDoSomething(element)) {
      <button mat-icon-button (click)="onContextMenu($event, element); $event.stopPropagation()" style="outline: none;"
        title="Scenario Template Menu">
        <mat-icon class="mdi-18px" fontIcon="mdi-menu"></mat-icon>
      </button>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
    <td mat-cell *matCellDef="let element">{{ element.description }}</td>
  </ng-container>

  <ng-container matColumnDef="durationHours">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Duration</th>
    <td mat-cell *matCellDef="let element">{{ element.durationHours }}</td>
  </ng-container>

  <ng-container matColumnDef="dateCreated">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
    <td mat-cell *matCellDef="let element">{{ element.dateCreated | date: 'yyyy-MM-dd' }}</td>
  </ng-container>

  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
      <div [@detailExpand]="element.id === expandedScenarioTemplateId ? 'expanded' : 'collapsed'"
        (click)="$event.stopPropagation()">
        @if (element.id === expandedScenarioTemplateId) {
          @if (adminMode) {
          <div class="memberships-container">
            <label class="memberships-label">Memberships</label>
            <app-scenario-template-memberships [scenarioTemplateId]="element.id"
              [showHeader]="false"></app-scenario-template-memberships>
          </div>
          } @else {
          <app-scenario-template-edit [scenarioTemplate]="selectedScenarioTemplate"></app-scenario-template-edit>
          }
        }
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns" class="element-row"
    (click)="selectScenarioTemplate($event, row.id)" (contextmenu)="onContextMenu($event, row)"></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
</table>
</div>

@if (isLoading) {
<div>
  <div flex>
    <mat-progress-spinner color="accent" mode="indeterminate">
    </mat-progress-spinner>
  </div>
</div>
}

<div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x"
  [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu"></div>
<mat-menu #contextMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    @if (canEdit(item)) {
    <button mat-menu-item (click)="editScenarioTemplate(item)">
      Edit
    </button>
    }
    @if (hasPermission(SystemPermission.CreateScenarioTemplates)) {
    <button mat-menu-item (click)="copyScenarioTemplate(item)">
      Copy
    </button>
    }
    @if (canManage(item)) {
    <button mat-menu-item (click)="deleteScenarioTemplate(item)">
      Delete
    </button>
    }
    @if (hasPermission(SystemPermission.CreateScenarios)) {
    <button mat-menu-item (click)="createScenario(item)">
      Create a Scenario
    </button>
    }
  </ng-template>
</mat-menu>
